import React, { useState, useEffect } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import Select from "react-select";
import Button from "../Button";

export default function CaveatPicker({ ids, type, onApply }) {
  const [resultCaveats, setResultCaveats] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const caveatIds = resultCaveats.map((c) => c.value);

  useEffect(() => {
    fetchJson("/sample_testing/caveats", { type: type }).then((json) => {
      setResultCaveats(json.caveats.map((c) => ({ value: c.id, label: c.caveat })));
    });
  }, []);

  const handleSubmit = () => {
    if (!selectedValue) return;
    var url =
      type == "result" ? "/sample_testing/result_caveats" : "/sample_testing/sample_caveats";
    post(url, {
      ids,
      caveat_ids: selectedValue.map((c) => c.value),
    })
      .then((json) => {
        onApply();
        setSelectedValue(null);
      })
      .catch((e) => alert(e));
  };

  return (
    <div className="row">
      <div className="col-md-8" style={{ paddingRight: 0, textAlign: "right" }}>
        <Select
          value={selectedValue}
          options={resultCaveats}
          onChange={setSelectedValue}
          isMulti
        />
      </div>
      <div className="col-md-4">
        <Button
          onClick={handleSubmit}
          block
          title={"Apply Caveats"}
          primary
          style={{ height: 38 }}
        />
      </div>
    </div>
  );
}
